// src/features/event/pages/EventLegalTermsPage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { eventCard, EVENT_LOGO } from "../eventCard";
import { COLOR, FW } from "@/ui/tokens";

const SECTIONS = [
    {
        title: "제1조 (목적)",
        body: "본 약관은 회사가 제공하는 독서 기록 기반 서비스의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.",
    },
    {
        title: "제2조 (정의)",
        body: "1. 서비스란 독서 기록, 리뷰 작성, 콘텐츠 제공 등을 의미합니다.\n2. 회원이란 본 약관에 동의하고 서비스를 이용하는 자를 의미합니다.\n3. 콘텐츠란 회원이 작성한 모든 정보를 의미합니다.",
    },
    {
        title: "제3조 (약관의 명시와 개정)",
        body: "1. 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 내에 게시합니다.\n2. 회사는 「약관의 규제에 관한 법률」, 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관련 법령을 위반하지 않는 범위에서 본 약관을 개정할 수 있습니다.\n3. 약관 변경 시 적용일자 및 변경 내용을 사전 공지합니다.\n4. 회원이 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.",
    },
    {
        title: "제4조 (서비스의 제공)",
        body: "회사는 다음과 같은 서비스를 제공합니다:\n· 독서 기록 및 관리 기능\n· 리뷰 및 별점 작성 기능\n· 책 검색 및 콘텐츠 탐색 기능\n· 개인화 콘텐츠 제공\n· 기타 서비스 운영 및 개선 기능",
    },
    {
        title: "제5조 (서비스의 변경 및 중단)",
        body: "1. 회사는 운영상 필요에 따라 서비스 내용을 변경할 수 있습니다.\n 2.시스템 점검, 장애, 정책 변경 등의 경우 서비스 제공이 일시 중단될 수 있습니다.\n 3.베타 서비스의 경우 기능이 변경되거나 제한될 수 있습니다.",
    },
    {
        title: "제6조 (회원가입 및 가입 제한)",
        body: "1. 이용자는 회사가 정한 절차에 따라 회원가입을 신청할 수 있습니다.\n2. 회사는 다음 각 호에 해당하지 않는 한 회원으로 등록합니다:\n· 허위 정보를 입력한 경우\n· 타인의 정보를 도용한 경우\n· 법령 위반 이력이 있는 경우\n· 서비스 운영에 중대한 지장을 줄 우려가 있는 경우\n· 기타 회사가 부적절하다고 판단하는 경우\n3. 다음의 경우 가입이 제한될 수 있습니다:\n· 탈퇴 후 30일 이내 재가입 신청. 이 경우 회사는 재가입 방지를 위해 탈퇴일로부터 30일간 이메일 주소 및 휴대폰 번호(암호화 처리)를 보관하며, 해당 기간 종료 후 즉시 파기합니다.\n· 동일한 정보로 중복 가입 시도\n4. 회원은 정확한 정보를 제공해야 하며, 변경 시 즉시 수정해야 합니다.(미수정으로 인한 책임은 회원에게 있습니다.)",
    },
    {
        title: "제7조 (회원 탈퇴 및 자격 상실)",
        body: "1. 회원은 언제든지 탈퇴를 요청할 수 있으며 회사는 이를 즉시 처리합니다.\n2. 다음의 경우 탈퇴가 제한될 수 있습니다:\n· 진행 중인 거래 또는 서비스 이용이 완료되지 않은 경우\n· 회사에 대한 채무가 존재하는 경우\n3. 회사는 다음의 경우 회원 자격을 제한 또는 상실시킬 수 있습니다:\n· 약관 위반\n· 서비스 운영 방해\n· 타인 권리 침해\n4. 회원이 탈퇴를 원하는 경우, 아래 고객지원 센터에 직접 연락하여 탈퇴를 신청하여야 합니다. 서비스 내 자동 탈퇴 기능은 제공되지 않습니다.\n   이노스페이스원 고객지원 센터\n   이메일: cs_as@innowaveglobal.com\n  전화번호: 031-689-4548\n  운영시간: 평일 10:00~17:30 (주말 및 공휴일 제외)\n5. 탈퇴 후 개인정보 처리\n회원 탈퇴 시 수집된 개인정보는 원칙적으로 지체 없이 파기합니다. 단, 다음의 경우 아래 기간 동안 보관합니다\n· 휴대폰 번호(암호화), 생일 → 30일\n· 본인확인 기록 → 6개월 (정보통신망법)\n· 접속 로그 → 3개월 (통신비밀보호법)",
    },
    {
        title: "제8조 (회원의 의무)",
        body: "회원은 다음 행위를 해서는 안 됩니다:\n· 허위 정보 등록\n· 타인의 계정 도용\n· 서비스 운영 방해\n· 저작권 침해\n· 불법 또는 부적절한 콘텐츠 게시",
    },
    {
        title: "제9조 (콘텐츠의 권리 및 이용)",
        body: "1. 회원이 작성한 콘텐츠의 저작권은 회원에게 있습니다.\n2. 회사는 서비스 운영, 홍보, 기능 제공을 위해 해당 콘텐츠를 사용할 수 있습니다.\n3. 회원은 타인의 권리를 침해하지 않아야 합니다.",
    },
    {
        title: "제10조 (게시물의 관리)",
        body: "1. 회원의 게시물은 서비스 내에서 공개될 수 있습니다.\n2. 회사는 다음의 게시물을 사전 통지 없이 삭제 또는 제한할 수 있습니다:\n· 법령 위반\n· 타인의 권리 침해\n· 서비스 목적에 부합하지 않는 내용\n\n권리 침해가 발생한 경우, 피해자는 게시중단을 요청할 수 있으며 회사는 관련 법령에 따라 조치합니다.",
    },
    {
        title: "제11조 (게시물의 보관 및 삭제)",
        body: "1. 게시물은 서비스 운영 정책에 따라 보관됩니다.\n2. 회사는 정책에 따라 게시물을 삭제할 수 있습니다.\n3. 삭제된 게시물에 대해 복구 의무를 지지 않습니다.\n4. 회원 탈퇴 시 게시물 처리\n\n회원이 탈퇴하는 경우 해당 회원이 작성한 게시물(리뷰, 댓글 등)은 다음과 같이 처리됩니다:\n· 게시물의 내용은 서비스의 정보 연속성을 위해 익명화된 형태로 유지될 수 있습니다.\n· 게시물에 포함된 개인 식별 정보(닉네임, 프로필 등)는 탈퇴 즉시 삭제 또는 비식별화 처리됩니다.\n· 회원은 탈퇴 전 본인 게시물을 직접 삭제할 수 있으며, 삭제하지 않은 게시물은 위 기준에 따라 처리됩니다.",
    },
    {
        title: "제12조 (서비스 이용 제한)",
        body: "회사는 다음의 경우 서비스 이용을 제한할 수 있습니다:\n· 약관 위반\n· 비정상적인 서비스 이용\n· 시스템 악용 행위",
    },
    {
        title: "제13조 (개인정보 보호)",
        body: "1. 회사는 관련 법령에 따라 개인정보를 보호합니다.\n2. 자세한 사항은 개인정보처리방침에 따릅니다.",
    },
    {
        title: "제14조 (면책조항)",
        body: "1. 회사는 회원이 게시한 정보의 정확성에 대해 책임지지 않습니다.\n2. 회사는 시스템 장애, 불가항력으로 인한 손해에 대해 책임을 지지 않습니다.",
    },
    {
        title: "제15조 (분쟁 해결)",
        body: "회사와 회원 간 분쟁 발생 시 성실히 협의합니다.",
    },
    {
        title: "제16조 (준거법 및 관할)",
        body: "본 약관은 대한민국 법을 따르며, 분쟁은 관할 법원에 따릅니다.",
    },
];

function renderBody(text: string) {
    return text.split("\n").map((line, i, arr) => (
        <React.Fragment key={i}>
            {line}
            {i < arr.length - 1 && <br />}
        </React.Fragment>
    ));
}

export default function EventLegalTermsPage() {
    const nav = useNavigate();

    const handleAgree = () => {
        nav("/event/agree", { state: { agreed: "terms" }, replace: true });
    };

    return (
        <div style={eventCard.wrap}>
            <div style={{ ...eventCard.card, width: 480, maxHeight: "92vh", display: "flex", flexDirection: "column" }}>
                {/* Header */}
                <div style={eventCard.header}>
                    <div style={eventCard.logoBox}>
                        <img src={EVENT_LOGO} alt="" style={{ width: 28, height: 28, filter: "invert(1)" }} />
                    </div>
                    <h1 style={eventCard.title}>서비스 이용약관</h1>
                    <p style={eventCard.subtitle}>전체 약관을 확인하신 후 동의해주세요</p>
                </div>

                {/* Scrollable content */}
                <div style={s.scrollBody}>
                    {SECTIONS.map((sec) => (
                        <div key={sec.title} style={s.section}>
                            <div style={s.sectionTitle}>{sec.title}</div>
                            <p style={s.sectionBody}>{renderBody(sec.body)}</p>
                        </div>
                    ))}
                </div>

                {/* Footer with agree button */}
                <div style={s.footer}>
                    <button
                        onClick={handleAgree}
                        style={eventCard.ctaBtn}
                        onMouseEnter={e => (e.currentTarget.style.background = "#27272a")}
                        onMouseLeave={e => (e.currentTarget.style.background = "#18181b")}
                    >
                        동의하고 돌아가기
                    </button>
                </div>
            </div>
        </div>
    );
}

const s: Record<string, React.CSSProperties> = {
    scrollBody:   { flex: 1, overflowY: "auto", padding: "20px 28px", display: "flex", flexDirection: "column", gap: 16 },
    section:      { display: "flex", flexDirection: "column", gap: 6 },
    sectionTitle: { fontSize: 13, fontWeight: FW.extraBold, color: COLOR.textDark },
    sectionBody:  { margin: 0, fontSize: 12, color: "#52525b", lineHeight: 1.75, whiteSpace: "pre-line" },
    footer:       { padding: "16px 28px 24px", borderTop: "1px solid #f4f4f5", display: "flex", flexDirection: "column" },
};